import React from 'react';
import { Info } from 'lucide-react';
import { TONE_BAR, statusMeta } from './opsMeta';

// Répartition par statut — barres horizontales cliquables (filtre la file).
export const StatusDistribution = ({ funnel = [], onSelectStatus }) => {
  const total = funnel.reduce((acc, s) => acc + (s.count || 0), 0);
  const max = Math.max(...funnel.map((s) => s.count || 0), 1);

  return (
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm" data-testid="ops-status-distribution">
      <div className="flex items-center gap-1.5 border-b border-gray-100 px-5 py-4">
        <h2 className="text-base font-semibold tracking-tight text-gray-900">Répartition par statut</h2>
        <Info className="h-3.5 w-3.5 text-gray-300" />
      </div>
      <div className="space-y-3 px-5 py-4">
        {funnel.map((s) => {
          const meta = statusMeta(s.key);
          const pct = total ? Math.round((s.count / total) * 100) : 0;
          return (
            <button
              key={s.key}
              type="button"
              onClick={() => onSelectStatus && onSelectStatus(s.key)}
              data-testid={`ops-status-row-${s.key}`}
              className="group flex w-full items-center gap-3 rounded-md px-1 py-0.5 text-left transition-colors hover:bg-gray-50"
            >
              <span className="w-40 shrink-0 truncate text-sm text-gray-600 group-hover:text-gray-900">{s.label}</span>
              <span className="relative h-2.5 flex-1 overflow-hidden rounded-full bg-gray-100">
                <span
                  className={`absolute inset-y-0 left-0 rounded-full ${TONE_BAR[meta.tone] || TONE_BAR.slate} transition-all`}
                  style={{ width: `${Math.max(2, (s.count / max) * 100)}%` }}
                />
              </span>
              <span className="w-16 shrink-0 text-right text-sm font-semibold tabular-nums text-gray-900">{s.count}</span>
              <span className="w-12 shrink-0 text-right text-xs tabular-nums text-gray-400">{pct}%</span>
            </button>
          );
        })}
      </div>
      <div className="flex items-center justify-between border-t border-gray-100 px-5 py-3">
        <span className="text-sm font-medium text-gray-500">Total opérations</span>
        <span className="text-base font-bold tabular-nums text-gray-900" data-testid="ops-status-total">{total}</span>
      </div>
    </div>
  );
};

export default StatusDistribution;
